export type LicensePointStatus = 'Ativo' | 'Removido' | 'SemPonto'

export interface ILicenseSituation {
  clientId: string
  cliente?: string
  /** Contrato por pontos ativo para o cliente. Desativada, nada é bloqueado; só se conta. */
  ativa: boolean
  totalPontos: number
  usados: number
  disponiveis: number
  removidos: number
  /** Comissionados que não conseguiram ponto: sem gravar e sem receber comando por falta de saldo. */
  aguardandoPonto: number
  limiteAtingido: boolean
  /** Mais pontos em uso do que o total: o total foi reduzido abaixo do uso. */
  excedida: boolean
  percentualUso: number
  alteradoPor?: string
  alteradoEm?: string
  /** Se a licença está sendo aplicada na gravação e nos comandos neste ambiente. */
  habilitada: boolean
}

export interface ILicensePoint {
  meterId: string
  serial?: string
  status: LicensePointStatus
  atribuidoEm?: string
  removidoEm?: string
  removidoPor?: string
}

export interface ILicenseActionResult {
  serial: string
  sucesso: boolean
  mensagem: string
}

/** A partir deste uso a tela avisa que o limite está próximo. */
export const LICENSE_WARNING_PERCENT = 90
